const rasterImages = require.context('.', false, /\.(png|jpe?g|gif)$/i)
rasterImages.keys().forEach(rasterImages)
